import script from "./CadastroResponsavel.vue?vue&type=script&setup=true&lang=js"
export * from "./CadastroResponsavel.vue?vue&type=script&setup=true&lang=js"

import "./CadastroResponsavel.vue?vue&type=style&index=0&id=9fedc730&scoped=true&lang=css"

import exportComponent from "D:\\FOP\\AGAPE\\AGAPE_HOSPITALAR\\ReguaHospitalar\\frontpainel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9fedc730"]])

export default __exports__